import { ALZHEIMER_TEST_TRIAL } from '@modules/trials/constants/trials'

export const STRUCTURED_QUESTION_UNSURE = 'Not Sure'
export const STRUCTURED_QUESTION_NONE = 'None'

export const CommonComorbidityNames: string[] = [
  'Schizophrenia',
  'Depression',
  'Generalized Anxiety Disorder',
  'Bipolar Disorder',
  'Substance Abuse',
  'Obsessive-Compulsive Disorder',
  'Body Dysmorphic Disorder',
  'Premenstrual Dysphoric Disorder',
  'Agoraphobia',
  'Social Anxiety Disorder',
  'Post-Traumatic Stress Disorder',
]

// TODO: Use type similar to popular medications by incorporating condition name and colloquialTermStripped
type ComorbiditiesByTrial = {
  comorbidities: string[]
  nctIds: string[]
}

export const CommonComorbidityNamesByNctId: ComorbiditiesByTrial[] = [
  {
    comorbidities: [
      'Hypertension',
      'Coronary Artery Disease',
      'Atrial Fibrillation',
      'Type 2 Diabetes',
      'Heart Disease',
      'Depression',
      'Anxiety',
      'Parkinson’s Disease',
      'Osteoporosis',
      'Hypothyroidism',
    ],
    // Alzheimer's Disease
    nctIds: [ALZHEIMER_TEST_TRIAL.nctId],
  },
]
